import React from 'react';

import { createLinksForEntities } from 'buyside/util/tagRendererHelper';
import ArticlePreview from 'buyside/components/presentation/Feed/ArticlePreview/articlePreview';
import FeedHeading from 'buyside/components/presentation/Feed/FeedHeading/feedHeading';
import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';

import styles from 'buyside/components/presentation/Feed/AdminPost/adminPostStyles.scss';

const AdminPost = props => {
  const { adminPost, createdAt, eventVerb, registerClickedLink } = props;
  const convertTagToLink = (tag, idx) => {
    const symbol = tag.match(/\(([^\)]+)\)$/)[1];
    const display = tag.match(/\[([^\]]+)\]/)[1];
    return `<a name="${idx}-${symbol}" href="/pro/assets/${symbol}" target="_blank">
        ${display}
      </a>`;
  };

  const defaultCallback = result => {
    return result;
  };

  const isAnchorTag = htmlNode => {
    return htmlNode && htmlNode.__proto__ === HTMLAnchorElement.prototype ? true : false;
  };

  const clickHandler = event => {
    const link = event.target.closest('a');
    if (registerClickedLink && isAnchorTag(link)) {
      registerClickedLink(adminPost.id, link.href);
    }
  };

  return (
    <div>
      <div className={styles.feedItemHeaderWrap}>
        <div className={styles.feedItemHeader}>
          <FeedHeading
            user={adminPost.user}
            createdAt={createdAt}
            showUserDetails
            headerType={eventVerb}
          />
        </div>
      </div>
      <div className={styles.adminPostContent} id={`${adminPost.id}-post`}>
        <div onClick={clickHandler}>
          <ParsedHtml
            html={createLinksForEntities(adminPost.body, convertTagToLink, defaultCallback).join(
              ''
            )}
          >
            {({ content }) => <div className={styles.adminPostText}>{content}</div>}
          </ParsedHtml>
          <ArticlePreview {...adminPost} />
        </div>
      </div>
    </div>
  );
};

export default AdminPost;
